import { Image } from '../website/Image';


export class DeckImage extends Image {
	public deckId: string;

	constructor(init?: Partial<DeckImage>) {
		super();
		Object.assign(this, init);
	}

}
